import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const CorporateSolutions = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <div>
      <div className="px-6 md:px-[4.5rem] py-12 pt-[6rem] md:pt-[9rem] bg-[#DC143C] md:flex justify-between items-center gap-40">
        <div className="md:w-1/2">
          <h2 className="text-[#FFF] font-[Figtree] text-[0.75rem] md:text-[1rem] text-center md:text-left font-medium leading-[2.375rem] tracking-[0.26rem] uppercase">
            Corporate Solutions
          </h2>
          <h2 className="md:w-[88%] text-[#FFF] font-[Figtree] text-[1.9375rem] md:text-[2.875rem] text-center md:text-left font-medium leading-[2.6875rem] md:leading-[3.6875rem] tracking-[-0.0775rem] md:tracking-[-0.115rem]">
            Empower your business with{" "}
            <span className="font-extrabold">secure,</span>{" "}
            <span className="font-bold">efficient,</span> and
            <span className="font-extrabold"> transparent </span>
            financial management tools.
          </h2>
        </div>
        <div className="md:w-1/2 flex justify-end mt-8 md:mt-0">
          <img
            src="/assets/corporationBlockImg.png"
            alt="CurrencyExchangeLeft"
          />
        </div>
      </div>

      <div className=" p-6 md:p-[4.5rem] md:flex items-center gap-[15rem]">
        <div className="md:w-1/2">
          <h2 className="font-[Figtree] font-light text-[2.1875rem] md:text-[2.875rem] leading-[3rem] md:leading-[4.375rem]">
            <span className="font-bold text-[#DC143C]">
              Exclusive Perks with nimo:
            </span>{" "}
            More Than Just Forex Card
          </h2>
          <div>
            <Link to={"/support"}>
              <button className="text-[#FCF7F8] font-[Figtree] text-[0.75rem] md:text-[1.09738rem] font-semibold leading-[0.9145rem] bg-[#DC143C] py-[0.9145rem] px-[1.69175rem] rounded-lg mt-6 md:mt-12">
                Contact Us
              </button>
            </Link>
          </div>
        </div>
        {/* <div className="md:w-1/2 grid grid-cols-2 md:gap-y-10 custom-grid">
          <div className="md:w-[15.36131rem] md:h-[17.18544rem] rounded-[0.38406rem] md:border border-[#F0F0F0] pl-[1.01rem] pt-7 pr-[1.49rem] pb-[0.96rem]">
            <img src="/assets/UserFriendlyIcon.png" alt="UserFriendlyIcon" />
            <h2 className="font-[Figtree] text-[#1D1D1D] text-[0.91288rem] md:text-[1.152rem] font-bold leading[1.68rem] tracking-[-0.04606rem] my-[1.04rem]">
              User-Friendly Dashboard
            </h2>
            <p className="font-[Figtree] text-[#252525] text-[0.60856rem] md:text-[0.76806rem] font-normal leading[1.20013rem] tracking-[-0.04606rem]">
              Gain full visibility of your company’s financial activities
              through our intuitive and centralized dashboard. Manage all
              transactions, expenses, and funds in one place.
            </p>
          </div>
          <div className="md:w-[15.36131rem] md:h-[17.18544rem] rounded-[0.38406rem] md:border border-[#F0F0F0] pl-[1.01rem] pt-7 pr-[1.49rem] pb-[0.96rem]">
            <img src="/assets/ClockServiceIcon.png" alt="ClockServiceIcon" />
            <h2 className="font-[Figtree] text-[#1D1D1D] text-[0.91288rem] md:text-[1.152rem] font-bold leading[1.68rem] tracking-[-0.04606rem] my-[1.04rem]">
              Around-the-Clock Service
            </h2>
            <p className="font-[Figtree] text-[#252525] text-[0.60856rem] md:text-[0.76806rem] font-normal leading[1.20013rem] tracking-[-0.04606rem]">
              With Nimo, your business never stops. Enjoy 24/7 support and
              service to ensure seamless financial operations anytime, anywhere.
            </p>
          </div>
          <div className="md:w-[15.36131rem] md:h-[17.18544rem] rounded-[0.38406rem] md:border border-[#F0F0F0] pl-[1.01rem] pt-7 pr-[1.49rem] pb-[0.96rem]">
            <img
              src="/assets/Multi-LevelAuthorizationIcon.png"
              alt="MultiLevelAuthorizationIcon"
            />
            <h2 className="font-[Figtree] text-[#1D1D1D] text-[0.91288rem] md:text-[1.152rem] font-bold leading[1.68rem] tracking-[-0.04606rem] my-[1.04rem]">
              Multi-Level Authorization
            </h2>
            <p className="font-[Figtree] text-[#252525] text-[0.60856rem] md:text-[0.76806rem] font-normal leading[1.20013rem] tracking-[-0.04606rem]">
              Add layers of security and control with customizable multi-level
              approval workflows for all financial activities.
            </p>
          </div>
          <div className="md:w-[15.36131rem] md:h-[17.18544rem] rounded-[0.38406rem] md:border border-[#F0F0F0] pl-[1.01rem] pt-7 pr-[1.49rem] pb-[0.96rem]">
            <img src="/assets/EasyOff-LoadIcon .png" alt="EasyOffLoadIcon " />
            <h2 className="font-[Figtree] text-[#1D1D1D] text-[0.91288rem] md:text-[1.152rem] font-bold leading[1.68rem] tracking-[-0.04606rem] my-[1.04rem]">
              Easy Load and Off-Load
            </h2>
            <p className="font-[Figtree] text-[#252525] text-[0.60856rem] md:text-[0.76806rem] font-normal leading[1.20013rem] tracking-[-0.04606rem]">
              Quickly load or off-load funds into corporate accounts or employee
              cards with just a few clicks, saving time and ensuring operational
              efficiency.
            </p>
          </div>
        </div> */}
        <div className="md:w-1/2 flex gap-[1.7rem]">
          <div>
            <div className="md:w-[15.36131rem] md:h-[20.18544rem] rounded-[0.38406rem] md:border border-[#F0F0F0] pl-[1.01rem] pt-7 pr-[1.49rem] pb-[0.96rem] mb-[1.82rem] mt-16">
              <img src="/assets/UserFriendlyIcon.png" alt="UserFriendlyIcon" />
              <h2 className="font-[Figtree] text-[#1D1D1D] text-[0.91288rem] md:text-[2rem] font-bold leading[1.68rem] tracking-[-0.04606rem] my-[1.04rem]">
                User-Friendly Dashboard
              </h2>
              <p className="font-[Figtree] text-[#252525] text-[0.875rem] md:text-[0.76806rem] font-normal leading[1.20013rem] tracking-[-0.04606rem]">
                Gain full visibility of your company’s financial activities
                through our intuitive and centralised dashboard. Manage all
                transactions, expenses, and funds in one place.
              </p>
            </div>
            <div className="md:w-[15.36131rem] md:h-[20.18544rem] rounded-[0.38406rem] md:border border-[#F0F0F0] pl-[1.01rem] pt-7 pr-[1.49rem] pb-[0.96rem]">
              <img
                src="/assets/Multi-LevelAuthorizationIcon.png"
                alt="MultiLevelAuthorizationIcon"
              />
              <h2 className="font-[Figtree] text-[#1D1D1D] text-[0.91288rem] md:text-[2rem] font-bold leading[1.68rem] tracking-[-0.04606rem] my-[1.04rem]">
                Multi-Level Authorisation
              </h2>
              <p className="font-[Figtree] text-[#252525] text-[0.875rem] md:text-[0.76806rem] font-normal leading[1.20013rem] tracking-[-0.04606rem]">
                Add layers of security and control with customisable multi-level
                approval workflows for all financial activities.
              </p>
            </div>
          </div>
          <div>
            <div className="md:w-[15.36131rem] md:h-[20.18544rem] rounded-[0.38406rem] md:border border-[#F0F0F0] pl-[1.01rem] pt-7 pr-[1.49rem] pb-[0.96rem] mb-[1.82rem]">
              <img src="/assets/ClockServiceIcon.png" alt="ClockServiceIcon" />
              <h2 className="font-[Figtree] text-[#1D1D1D] text-[0.91288rem] md:text-[2rem] font-bold leading[1.68rem] tracking-[-0.04606rem] my-[1.04rem]">
                Around-the-Clock Service
              </h2>
              <p className="font-[Figtree] text-[#252525] text-[0.875rem] md:text-[0.76806rem] font-normal leading[1.20013rem] tracking-[-0.04606rem]">
                With Nimo, your business never stops. Enjoy 24/7 support and
                service to ensure seamless financial operations anytime,
                anywhere.
              </p>
            </div>
            <div className="md:w-[15.36131rem] md:h-[20.18544rem] rounded-[0.38406rem] md:border border-[#F0F0F0] pl-[1.01rem] pt-7 pr-[1.49rem] pb-[0.96rem]">
              <img src="/assets/EasyOff-LoadIcon .png" alt="EasyOffLoadIcon " />
              <h2 className="font-[Figtree] text-[#1D1D1D] text-[0.91288rem] md:text-[2rem] font-bold leading[1.68rem] tracking-[-0.04606rem] my-[1.04rem]">
                Easy Load and Off-Load
              </h2>
              <p className="font-[Figtree] text-[#252525] text-[0.875rem] md:text-[0.76806rem] font-normal leading[1.20013rem] tracking-[-0.04606rem]">
                Quickly load or off-load funds into corporate accounts or
                employee cards with just a few clicks, saving time and ensuring
                operational efficiency.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-[#FCF7F8] px-6 md:px-[4.5rem] pt-8 md:pt-[4.8rem]">
        <h2 className="text-[#363636] font-[Figtree] text-[1.125rem] md:text-[2.3125rem] text-center md:text-left font-normal leading-8 md:leading-[3.875rem] mb-8">
          Corporate{" "}
          <span className="text-[#DC143C] font-extrabold">Dashboard</span>{" "}
          Features
        </h2>
        <div className="flex items-center">
          <div className="w-1/2">
            <h2 className="text-[#1D1D1D] font-[Figtree] text-[1rem] md:text-[3rem] font-bold leading-normal md:mr-40">
              Comprehensive Insights
            </h2>
            <p className="text-[#252525] font-[Figtree] text-[0.625rem] md:text-[1.1875rem] font-normal leading-[1.125rem] md:leading-[1.9375rem] md:mr-40">
              Get real-time data on all transactions, balances, and expenses for
              smarter financial decision-making.
            </p>
          </div>
          <div className="w-1/2 flex justify-end">
            <img
              src="/assets/ComprehensiveInsightsLeftImg.png"
              alt="ComprehensiveInsights"
              className="w-full"
            />
          </div>
        </div>
        <div className="flex items-center">
          <div className="w-1/2">
            <img
              src="/assets/RoleBasedIcon.png"
              alt="RoleBasedIcon"
              className="w-full"
            />
          </div>
          <div className="w-1/2">
            <h2 className="text-[#1D1D1D] font-[Figtree] text-[1rem] md:text-[3rem] font-bold leading-normal ml-5 md:ml-20">
              Role-Based Access
            </h2>
            <p className="text-[#252525] font-[Figtree] text-[0.625rem] md:text-[1.1875rem] font-normal leading-[1.125rem] md:leading-[1.9375rem] ml-5 md:ml-20">
              Assign access levels to employees based on their roles, ensuring
              sensitive data remains protected.
            </p>
          </div>
        </div>
        <div className="flex items-center">
          <div className="w-1/2">
            <h2 className="text-[#1D1D1D] font-[Figtree] text-[1rem] md:text-[3rem] font-bold leading-normal md:mr-40">
              Employee Card Management
            </h2>
            <p className="text-[#252525] font-[Figtree] text-[0.625rem] md:text-[1.1875rem] font-normal leading-[1.125rem] md:leading-[1.9375rem] md:mr-40">
              Issue, monitor, and control spending on employee cards with ease,
              all from the dashboard.
            </p>
          </div>
          <div className="w-1/2 flex justify-end">
            <img
              src="/assets/EmployementCardIcon.png"
              alt="EmployementCardIcon"
              className="w-full"
            />
          </div>
        </div>
        <div className="flex items-center">
          <div className="w-1/2">
            <img
              src="/assets/BudgetAllocationIcon.png"
              alt="BudgetAllocationIcon"
              className="w-full"
            />
          </div>
          <div className="w-1/2">
            <h2 className="text-[#1D1D1D] font-[Figtree] text-[1rem] md:text-[3rem] font-bold leading-normal ml-5 md:ml-20">
              Budget Allocation
            </h2>
            <p className="text-[#252525] font-[Figtree] text-[0.625rem] md:text-[1.1875rem] font-normal leading-[1.125rem] md:leading-[1.9375rem] ml-5 md:ml-20">
              Allocate budgets to teams or projects directly through the
              dashboard and track their spending in real-time.
            </p>
          </div>
        </div>
        <div className="flex items-center">
          <div className="w-1/2">
            <h2 className="text-[#1D1D1D] font-[Figtree] text-[1rem] md:text-[3rem] font-bold leading-normal md:mr-40">
              Custom Reporting
            </h2>
            <p className="text-[#252525] font-[Figtree] text-[0.625rem] md:text-[1.1875rem] font-normal leading-[1.125rem] md:leading-[1.9375rem] md:mr-40">
              Generate detailed financial reports tailored to your business
              needs, helping you stay compliant and informed.
            </p>
          </div>
          <div className="w-1/2 flex justify-end">
            <img
              src="/assets/CustomReportingIcon.png"
              alt="CustomReportingIcon"
              className="w-full"
            />
          </div>
        </div>
      </div>

      {/* <div className="md:flex items-center px-6 md:px-[4.5rem] mt-16">
        <div className="md:w-[30%] min-[1700px]:w-[25%]">
          <h2 className="text-[#1D1D1D] text-[1.79031rem] md:text-[2.3125rem] text-center md:text-left font-normal leading-[2.12288rem] md:leading-[3.875rem] mb-5 md:mb-9">
            Frequently Asked{" "}
            <span className="text-[#DC143C] font-bold">Questions</span>
          </h2>
          <div className="flex justify-center md:justify-start">
           <Link to={"/faq"}>
           <button className="bg-[#DC143C] py-3 px-[1.375rem] rounded-lg text-white font-[Figtree] text-[0.75rem] md:text-[1.25rem] font-semibold leading-5 tracking-[-.06rem]">
              View more
            </button></Link>
          </div>
        </div>
        <div className="md:w-[70%]  min-[1700px]:w-[75%]">
          Collapsible FAQ Items
          {[
            {
              question: "How do I apply for a Nimo Forex Card?",
              answer:
                "You can apply for a Nimo Forex Card through our mobile app or website. Simply sign up, load funds, and get started. Virtual cards are available instantly, and physical cards can be delivered to your doorstep.",
            },
            {
              question: "What currencies can I load on the card?",
              answer:
                "Nimo Forex Cards support all major international currencies, including USD, EUR, GBP, AUD, CAD, SGD, AED, and many more. Check the app for the full list.",
            },
            {
              question: "Can I lock in exchange rates while loading my card?",
              answer:
                "Yes! With Nimo Forex Cards, you can lock in real-time exchange rates while loading funds, protecting you from currency fluctuations.",
            },
            {
              question: "Where can I use my Nimo Forex Card?",
              answer:
                "You can use your card anywhere in the world where Visa/Mastercard is accepted, including ATMs, retail stores, and online platforms.",
            },
            {
              question: "Can I withdraw cash from ATMs with my Forex Card?",
              answer:
                "Yes! You can withdraw local currency from ATMs worldwide. Many ATMs are fee-free when you use your Nimo Forex Card.",
            },
            {
              question: "How can I contact support for assistance?",
              answer:
                "You can reach our customer support team 24/7 through the Nimo app, email, or hotline for any questions or issues.",
            },
          ].map((faq, index) => (
            <div
              key={index}
              className="border p-6 rounded-lg border-[#DEDEDE] text-left mt-[1.12rem] cursor-pointer"
              onClick={() => toggleFAQ(index)}
            >
              <div className="flex justify-between items-center">
                <h3
                  className={`text-[0.75rem] md:text-[1.25rem] leading-normal text-[#1D1D1D] font-[Figtree] tracking-tight 
                                ${
                                  openIndex === index
                                    ? "font-bold"
                                    : "font-medium"
                                }`}
                >
                  {faq.question}
                </h3>
                <span className="text-xl font-bold">
                  {openIndex === index ? (
                    <img
                      src="/assets/UpArrow.png"
                      alt="Collapse"
                      className="w-[0.8125rem] h-[0.5125rem]"
                    />
                  ) : (
                    <img
                      src="/assets/DownArrow.png"
                      alt="Expand"
                      className="w-[0.8125rem] h-[0.5125rem]"
                    />
                  )}
                </span>
              </div>
              {openIndex === index && (
                <p className="text-[#2F2A35] text-[0.625rem] md:text-[0.875rem] font-normal mt-2 leading-[1.34413rem] md:leading-[1.6875rem]">
                  {faq.answer}
                </p>
              )}
            </div>
          ))}
        </div>
      </div> */}
    </div>
  );
};

export default CorporateSolutions;
